function logWithTakt(context, details) {
  var _window, _window$logCustom;
  (_window = window) === null || _window === void 0 || (_window = _window.AmazonTakt) === null || _window === void 0 || (_window$logCustom = _window.logCustom) === null || _window$logCustom === void 0 || _window$logCustom.call(_window, {
    context,
    details: JSON.stringify(details)
  });
}

export { logWithTakt as l };
//# sourceMappingURL=logWithTakt-BL7gp6Oa.js.map
